<div *ngIf="data.message!=''" class="container-fluid ethemax">
    <div class="row">
        <div class="col-6">
            {{data.message}}
        </div>
        <div class="col-6 mr-auto">
            <button mat-raised-button class="mr-1" (click)="positive()">{{data.button1}}</button>
            <button mat-raised-button (click)="negative()">{{data.button2}}</button>
        </div>

    </div>
</div>
